<template>
  <transition name="fade">
    <base-modal
      v-if="show"
      class="modal-create-rsvp-invites has-text-centered"
      @modalState="(payload) => (show = payload)"
    >
      <template v-slot:content>
        <div class="content">
          <div class="title-modal">
            Não esqueça de cadastrar<br />
            os seus convidados 😉
          </div>

          <p>
            Você optou pelo modelo de <strong>RSVP fechado</strong>, neste caso,
            é necessário que você cadastre a lista de convidados.
          </p>
          <p>
            Você tem a opção de cadastrá-los agora clicando no botão abaixo ou
            mais tarde, acessando o menu lateral em:<br />
            <strong>"Meus convidados" > "Presenças confirmadas"</strong>
          </p>
          <p>O que deseja fazer?</p>
        </div>

        <div class="actions-wrapper">
          <button @click="close" class="button is-gray" type="button">
            Cadastrar convidados depois
          </button>
          <router-link
            class="button is-primary"
            :to="{ path: `/rsvp/cadastrar-convites` }"
          >
            Cadastrar convidados agora
          </router-link>
        </div>
      </template>
    </base-modal>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseModal from '@/components/BaseModal.vue'

export default {
  components: {
    BaseModal,
  },

  computed: {
    ...mapGetters({
      rsvpConfigs: 'getRsvpConfigs',
      rsvpAmountAllTotal: 'rsvpAmountAllTotal',
    }),
  },

  data() {
    return {
      show: false,
      data: undefined,
    }
  },

  mounted() {
    setTimeout(() => {
      const isShowed = window.sessionStorage.getItem(
        'modal-create-rsvp-invites'
      )

      if (
        !isShowed &&
        this.rsvpConfigs.mode === 'closed' &&
        this.rsvpAmountAllTotal <= 0
      ) {
        window.sessionStorage.setItem('modal-create-rsvp-invites', true)
        this.open()
      }
    }, 3000)
  },

  methods: {
    open() {
      this.show = true
    },

    close() {
      this.show = false
    },
  },
}
</script>

<style lang="scss">
.modal-create-rsvp-invites {
  .c-base-modal__wrapper {
    padding: 56px 24px;
    border-radius: 16px;
    max-width: calc(100% - 32px);
    @media screen and (min-width: 632px) {
      max-width: 600px;
    }
  }

  .content {
    max-width: 450px;
    margin: 0 auto 60px;

    p {
      margin: 10px auto;
      color: $neutral;
      font-size: 16px;
      strong {
        font-weight: bold;
        color: $neutral;
      }
    }
  }

  .actions-wrapper {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: 632px) {
      flex-direction: row;
    }
  }

  button {
    font-size: 16px;
  }

  .title-modal {
    margin-bottom: 30px;
    color: $gray-7;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
  }
}
</style>
